var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#af272f;}.b,.c,.d{fill:none;stroke:#003c71;stroke-linecap:round;stroke-width:3px;}.b{stroke-miterlimit:10;}.d{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1395 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(1395 524)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(741.894 529.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M683.334,54.363l6.028-5.914,6.153,5.914,6.385-5.914,6.751,5.914"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.541,1.6,0,0",
    transform: "translate(701.847 29.072) rotate(-28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.54,0,0,1.6",
    transform: "matrix(-0.883, -0.469, 0.469, -0.883, 688.758, 30.486)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 8.921,
    y2: 7.233,
    transform: "matrix(0.809, -0.588, 0.588, 0.809, 702.041, 29.625)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 7.233,
    x2: 8.921,
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 685.064, 35.476)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel10);
export default __webpack_public_path__ + "static/media/level10.c555b4abeaac6068914bc4103bb94ff6.svg";
export { ForwardRef as ReactComponent };